export const dialog = [{
  pluginName: ["dialogComponent"],
  color: "rgba(255,255,255,1)",
  name:"弹框",
  width:300,
  height:80,
  dialogWidth:800,
  dialogHeight:600,
  iframelinkUrlVal:"https://www.chaoxing.com/",
  dialogPositionPercent: true,
  dialogLeft: 50,
  dialogTop: 50,
  useSelfQuery: false
}]
